import DisplayDataServer from "../../components/admin/DisplayDataServer";

const Witness=()=>{
   return <DisplayDataServer name={"Temoignages"} type={"witness"}/>;
}

export default Witness;